import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {finalize} from "rxjs/operators";
import {GlobalSpinnerService} from "../../shared/components/global-spinner/global-spinner.service";

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
    constructor(private globalSpinner: GlobalSpinnerService) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
      this.globalSpinner.show();
        return next.handle(request).pipe(
            finalize(() => {
                this.globalSpinner.reset();
            })
        );
    }
}
